import State from '../../utils/state';
import configStore from '../../utils/config-store';

class DurationComponentState extends State {
  get defaultState() {
    return {
      value: null,
      precision: 'seconds',
      pad: false,
      showZeroParts: false,
      language: configStore.config.language,
      _isConnected: false
    };
  }
}

export default DurationComponentState;
